import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ProjectSetupDto, SummaryStageDto } from "../../data/CommandServiceDtos.generated";

@Component({
  standalone: false,
  selector: 'project-execution-stage',
  templateUrl: './project-execution-stage.component.html',
  styleUrls: ['./project-execution-stage.component.scss']
})
export class ProjectExecutionStageComponent implements OnInit, OnChanges {
  @Input() stage: SummaryStageDto;
  @Input() project: ProjectSetupDto = new ProjectSetupDto;

  projectActivityDisplayType: string = "";
  isExpanded: boolean = true;

  get hasChildren(): boolean {
    return !!(this.stage && this.stage.Stages && this.stage.Stages.length > 0);
  }

  constructor() { }

  toggleStage(): void {
    this.isExpanded = !this.isExpanded;
  }

  ngOnInit() {
    this.syncDisplayType();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['project']) {
      this.syncDisplayType();
    }
  }

  private syncDisplayType() {
    this.projectActivityDisplayType = (this.project && this.project.ActivitiesDisplayType) || '';
  }

  showPercentage(type) {
    return this.projectActivityDisplayType && this.projectActivityDisplayType != undefined ? this.projectActivityDisplayType.includes(type) : false;
  }

}
